import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material Standalone APIs
import { MatAnchor, MatButton, MatIconButton } from '@angular/material/button';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import {
  MatList,
  MatListItem,
  MatListItemIcon,
  MatListItemLine,
  MatListItemMeta,
  MatListItemTitle,
} from '@angular/material/list';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatFooterCell,
  MatFooterCellDef,
  MatFooterRow,
  MatFooterRowDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';

import {
  MatCard,
  MatCardActions,
  MatCardAvatar,
  MatCardContent,
  MatCardFooter,
  MatCardHeader,
  MatCardImage,
  MatCardSubtitle,
  MatCardTitle,
} from '@angular/material/card';

// Transloco
import { TranslocoModule } from '@jsverse/transloco';

// Skeleton Loader
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

// Pipes
import { ReverseArrayPipe } from './pipes/reverse-array.pipe';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { TranslateInputValuePipe } from './pipes/translate-input-value.pipe';

// Services
import { TranslateService } from '@services/translate.service';
import { MatPaginatorFlow } from './providers/paginator-flow';

const sharedPipes = [ReverseArrayPipe, StripHtmlPipe];

const sharedModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslocoModule,
  NgxSkeletonLoaderModule,

  // Material standalone
  MatButton,
  MatAnchor,
  MatIconButton,
  MatButtonToggle,
  MatButtonToggleGroup,
  MatCheckbox,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
  MatFormField,
  MatLabel,
  MatIcon,
  MatInput,
  MatDivider,
  MatList,
  MatListItem,
  MatListItemIcon,
  MatListItemLine,
  MatListItemMeta,
  MatListItemTitle,
  MatDivider,
  MatMenu,
  MatMenuItem,
  MatMenuTrigger,
  MatPaginator,
  MatProgressBar,
  MatProgressSpinner,
  MatSelect,
  MatOption,
  MatSlideToggle,
  MatSort,
  MatSortHeader,
  MatTooltip,
  MatTable,
  MatColumnDef,
  MatHeaderCell,
  MatCell,
  MatFooterCell,
  MatHeaderRow,
  MatRow,
  MatFooterRow,
  MatHeaderRowDef,
  MatRowDef,
  MatFooterRowDef,
  MatHeaderCellDef,
  MatCellDef,
  MatFooterCellDef,

  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardSubtitle,
  MatCardContent,
  MatCardFooter,
  MatCardImage,
  MatCardAvatar,
  MatCardActions,
];

@NgModule({
  declarations: [...sharedPipes],
  imports: [...sharedModules],
  exports: [...sharedModules, ...sharedPipes],
  providers: [
    MatDialog,

    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new MatPaginatorFlow(translateService).getPaginatorIntl(),
    },
    TranslateInputValuePipe,
  ],
})
export class AppSharedModule {}
